// This icon file is generated automatically.
var PCopyrightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M7 0a7 7 0 100 14A7 7 0 007 0zm0 12.81A5.81 5.81 0 117 1.2 5.81 5.81 0 017 12.8zm.09-8.32c.83 0 1.39.53 1.45 1.3 0 .07.06.12.13.12h.88c.04 0 .07-.04.07-.08 0-1.35-1.06-2.3-2.54-2.3-1.71 0-2.7 1.16-2.7 3.08v.81c0 1.9.99 3.05 2.7 3.05 1.47 0 2.54-.92 2.54-2.21a.07.07 0 00-.07-.07h-.89a.13.13 0 00-.12.11c-.07.72-.63 1.22-1.45 1.22-1.02 0-1.6-.75-1.6-2.1v-.81c0-1.36.58-2.12 1.6-2.12z", "fill-rule": "nonzero" } }] }, "name": "p-copyright", "theme": "outlined" };
export default PCopyrightOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PCopyrightOutlined.js
// module id = 3308
// module chunks = 0